import { getLocalDay } from 'theme/utils/timezone-helpers'
import { parse, stringify } from 'query-string'
import { isEmpty } from 'lodash-es'

const initialFilters = {
  type: undefined, // undefined || 'favourite'
  date: undefined, // undefined || 'Mon' || 'Tue' || ...
  // sessionTypes: [], // [] || ['Workshop', 'On Demand', ...]
  streams: [], // [] || ['Continuous Research', 'Launch', ...]
  stages: [], // [] || ['Main Stage', 'Launch', ...]
  formats: [], // [] || ['Talk', 'Panel', ...]
  deliveries: [], // [] || ['Live', 'ON-Demand']
  locations: [], // [] || ['Live', 'ON-Demand']
  conferenceTypes: [], // [] || ['conference', 'community']
}

export const FILTERS = {
  TYPE: 'type',
  DAY: 'day',
  // SESSION_TYPE: 'sessionType',
  STREAM: 'stream',
  STAGE: 'stage',
  FORMAT: 'format',
  // DELIVERY: 'delivery',
  LOCATIONS: 'locations',
  CONFERENCE_TYPE: 'conference',
}

export const prepareInitialFilters = (location) => {
  const search = location?.search ?? null
  const urlParams = getFiltersFromURL(search)

  return isEmpty(urlParams)
    ? initialFilters
    : {
        ...initialFilters,
        ...urlParams,
      }
}

export const getFiltersFromSessions = (sessions, localTimezone, conferenceTimezone) => {
  const timezone = conferenceTimezone ? conferenceTimezone : localTimezone
  const filters = {
    types: ['favourite'],
    days: [],
    // sessionTypes: [],
    streams: [],
    stages: [],
    formats: [],
    // deliveries: [],
    locations: [],
    conferenceTypes: [],
  }

  if (!sessions) return filters

  sessions.forEach((session) => {
    // Getting days
    const newDate = getLocalDay(session.data.UTC_Start_Time, timezone)

    if (filters.days.indexOf(newDate) === -1) {
      filters.days.push(newDate)
    }

    // // Getting sessions types
    // const sessionType = session.data.Session_Groups?.[0].data?.Group ?? null

    // if (sessionType && filters.sessionTypes.indexOf(sessionType) === -1) {
    //   filters.sessionTypes.push(sessionType)
    // }

    // Getting deliveries
    // const delivery = session.data.Session_Groups?.[0].data?.Delivery ?? null

    // if (delivery && filters.deliveries.indexOf(delivery) === -1) {
    //   filters.deliveries.push(delivery)
    // }

    const locations = session.data.Session_Groups?.[0].data?.Location ?? []

    if (locations.length > 0) {
      locations.forEach((location) => {
        if (!filters.locations.includes(location)) {
          filters.locations.push(location)
        }
      })
    }

    // Getting formats
    const format = session.data.Session_Groups?.[0].data?.Format ?? null

    if (format && filters.formats.indexOf(format) === -1) {
      if (['Registration', 'Opening / Closing', 'Break'].indexOf(format) === -1) filters.formats.push(format)
    }

    // Getting conferenceTypes
    const conference = session.data.Conference?.[0].data?.Type ?? null

    if (conference && filters.conferenceTypes.indexOf(conference) === -1) {
      filters.conferenceTypes.push(conference)
    }

    // Getting streams
    const stream = session.data.Stream?.[0].data?.Stream_Name ?? null

    if (stream && filters.streams.indexOf(stream) === -1) {
      filters.streams.push(stream)
    }

    // Getting streams
    const stage = session.data.Stage?.[0].data?.Stage_Name ?? null

    if (stage && filters.stages.indexOf(stage) === -1) {
      filters.stages.push(stage)
    }
  })

  return filters
}
const shouldBeArray = ['stages', 'streams', 'formats', 'conferenceTypes', 'deliveries', 'locations']
const allowedQueries = [
  'date',
  'stages',
  'type',
  'streams',
  'formats',
  'conferenceTypes',
  'deliveries',
  'locations',
]

export const getFiltersFromURL = (search) => {
  const urlParams = {}
  if (!search) {
    return urlParams
  }

  const locationParams = parse(search)

  allowedQueries.forEach((item) => {
    if (locationParams[item]) {
      let value = locationParams[item]
      if (shouldBeArray.includes(item)) {
        const isMultiple = typeof locationParams[item] === 'object'
        if (!isMultiple) {
          value = [locationParams[item]]
        }
      }
      urlParams[item] = value
    }
  })

  return urlParams
}

export const prepareURLString = (currentFilters, location) => {
  const newQueryString = {}

  if (currentFilters.type) {
    newQueryString.type = currentFilters.type
  }

  if (currentFilters.date) {
    newQueryString.date = currentFilters.date
  }

  // if (currentFilters.sessionTypes.length) {
  //   newQueryString.sessionTypes = currentFilters.sessionTypes
  // }
  if (currentFilters.formats.length) {
    newQueryString.formats = currentFilters.formats
  }
  if (currentFilters.deliveries.length) {
    newQueryString.deliveries = currentFilters.deliveries
  }
  if (currentFilters.locations.length) {
    newQueryString.locations = currentFilters.locations
  }
  if (currentFilters.conferenceTypes.length) {
    newQueryString.conferenceTypes = currentFilters.conferenceTypes
  }

  if (currentFilters.streams.length) {
    newQueryString.streams = currentFilters.streams
  }

  if (currentFilters.stages.length) {
    newQueryString.stages = currentFilters.stages
  }

  // merge in location.search
  const sections = location.search.slice(1, location.search.length).split('&')
  sections.forEach((section) => {
    const parts = section.split('=')
    if (!newQueryString[parts[0]]) newQueryString[parts[0]] = parts[1]
  })

  return stringify(newQueryString)
}
